import createOpenApiClient from "openapi-fetch";
import { apiFetchRequest, getOpenApiClientBaseUrl } from "../lib/api-transport";
import type { paths } from "@airange/generated-contracts/exam";

export const examAdminOpenApiClient = createOpenApiClient<paths>({
  baseUrl: getOpenApiClientBaseUrl(),
  fetch: apiFetchRequest,
});
